import Drawer from "@components/shared/Drawer";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import InventoryFilterForm from "../components/InventoryFilterForm";

interface IDrawerProps {
  open: boolean;
  defaultValue?: any;
  onClose: () => void;
  onSave: any;
}
function InventoryTableFilterDrawer({
  defaultValue,
  open,
  onClose,
  onSave,
}: IDrawerProps) {
  const { t } = useTranslation();

  const filterForm = useFormik<any>({
    initialValues: defaultValue ?? ({} as any),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values: any) => {
      onSave(values);
      onClose();
    },
  });

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={t("filter")}
      onSave={() => filterForm.handleSubmit()}
      size="auto"
      width={"80%"}
    >
      <InventoryFilterForm filterForm={filterForm} />
    </Drawer>
  );
}

export default InventoryTableFilterDrawer;
